<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('Plate_Intials')"
                    v-model="form.plate_initials"
                    outlined
                    dense
                    hide-details="auto"
                    >
                </v-text-field>
            </v-col>
            <v-col>
                <v-text-field
                    :label="$t('Plate_No')"
                    v-model="form.plate_number"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
            <v-col>
                <v-autocomplete
                    :label="$t('Plate_Type')"
                    v-model="form.plate_type"
                    outlined
                    :items="plateTypes"
                    item-text="value"
                    item-value="key"
                    dense
                    hide-details="auto">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('Unit_No')"
                    v-model="form.unit_number"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[isRequired]">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    :label="$t('Brand')"
                    v-model="form.brand_id"
                    outlined
                    dense
                    hide-details="auto"
                    :items="brands"
                    item-text="name"
                    item-value="id"
                    @change="handleBrandChange"
                    :rules="[isRequired]"
                    >
                </v-autocomplete>
            </v-col>
            <v-col>
                <v-autocomplete
                    :label="$t('Model')"
                    v-model="form.model_id"
                    :items="brandModels"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[isRequired]">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    :label="$t('Type')"
                    :items="usages"
                    v-model="form.usage_id"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[isRequired]">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('Manufacture_Year')"
                    v-model="form.manufacture_year"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('VIN')"
                    v-model="form.vin"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
                
            </v-col>
            <v-col>
                <v-text-field
                    :label="$t('engine_number')"
                    v-model="form.engine_number"
                    outlined
                    dense
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    :label="$t('Dimension')"
                    v-model="form.dimension_id"
                    :items="dimensions"
                    @update:search-input="searchDimensionsAsync"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="[isRequired]"
                ></v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import vehicleAPI from './../../services/fleet/vehicle';
import brandAPI from './../../services/fleet/brand';
import modelAPI from './../../services/fleet/model';
import dimensionAPI from './../../services/fleet/dimension';
import usageAPI from './../../services/fleet/vehicleUsage';
import { isRequired } from './../../utils/validations';

export default {
    props: {
        value: Object
    },
    data() {
        return {
            plateTypes: [],
            brands: [],
            brandModels: [],
            dimensions: [],
            usages: [],
            form: {
                plate_initials: "",
                plate_number: "",
                plate_type: "",
                unit_number: "",
                brand_id: null,
                model_id: null,
                usage_id: null,
                manufacture_year: "",
                vin: "",
                engine_number: "",
                dimension_id: null
            }
        }
    },
    watch: {
        form: {
            deep: true,
            handler(value) {
                this.$emit("input", {
                    ...value,
                    manufacture_year: Number(value.manufacture_year)
                })
            }
        }
    },
    methods: {
        isRequired,
        fetchPlateTypesAsync() {
            this.plateTypes = [];
            vehicleAPI.plateTypes().then(response => {
                this.plateTypes = response.data
            })
        },
        fetchBrandsAsync() {
            this.brands = [];
            brandAPI.list().then(response => {
                this.brands = response.data
            })
        },
        fetchModelsOfBrand() {
            this.brandModels = [];
            modelAPI.listByBrand(this.form.brand_id).then(response => {
                this.brandModels = response.data
            })
        },
        searchDimensionsAsync(query) {
            dimensionAPI.search(query).then(response => {
                this.dimensions = Array.from(new Set([...this.dimensions, ...response.data]));
            });
        },
        fetchVehicleUsages() {
            usageAPI.list().then(response => {
                this.usages = response.data
            })
        },
        validate() {
            return this.$refs.form.validate();
        },
        handleBrandChange() {
            this.form.model_id = null;
            this.fetchModelsOfBrand();
        },
        fill() {
            let v = this.value;
            if(v) {
                this.form = {...v}
                if(v.dimension) this.dimensions = Array.from(new Set([...this.dimensions, v.dimension]))
                if(v.usage) this.usages = Array.from(new Set([...this.usages, v.usage]))
                if(v.model && v.model.brand) {
                    this.brands = Array.from(new Set([...this.brands, v.model.brand]))
                    this.brandModels = Array.from(new Set([...this.brandModels, v.model]))
                }
            }
        }
    },
    created() {
        this.fetchPlateTypesAsync();
        this.fetchBrandsAsync();
        this.fetchVehicleUsages();
        this.fill();
    }
}
</script>

<style>

</style>